import React from "react"
import { bp } from "../../utils/MediaQueries"
import { Button, ButtonProps } from "./Buttons"

type QuizButtonProps = ButtonProps & {}

export default function QuizButton({ ...props }: QuizButtonProps) {
  return <Button h={bp("4rem", "3rem")} {...props} />
}
